<template>
  <span>
    <v-layout
        v-if="loading"
        justify-center
        align-center
        class="loading-indicator"
    >
      <v-progress-circular
          indeterminate
          :size="70"
          :width="7"
      />
    </v-layout>
    <account-emails-details
        v-if="editing"
        :data="selectedItem"
        @close="close">
    </account-emails-details>
    <v-card
        v-show="!firstLoading && !editing"
        class="main-card"
    >
      <v-card-title>
        <p class="text-h5">Email адреса аккаунта</p>
        <v-spacer></v-spacer>
        <v-btn
            fab
            color="primary"
            @click="addEmail"
            title="Добавить"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="emails"
          :options.sync="options"
          :server-items-length="serverItemsLength"
          fixed-header
          no-data-text="Нет данных для отображения"
          :footer-props="{
          itemsPerPageText: 'Число email на странице',
          itemsPerPageOptions: [25, 50]
        }"
          dense
      >
        <template v-slot:item="{ item }">
          <tr @click="getDetails(item)" class="link-row">
            <td>{{ item.name }}</td>
            <td>{{ item.smtp_user }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </span>
</template>

<script>
import AccountEmailsDetails from './AccountEmailsDetails'
export default {
  name: 'AccountEmails',
  components: {
    AccountEmailsDetails
  },
  data () {
    return {
      loading: true,
      firstLoading: true,
      options: { page: 1, itemsPerPage: 25 },
      selectedItem: {},
      emails: [],
      editing: false,
      serverItemsLength: 0,
      headers: [
        {
          text: 'Название почты',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Логин',
          align: 'left',
          sortable: false,
          value: 'smtp_user'
        }
      ],
      getTimer: ''
    }
  },
  watch: {
    options: {
      handler () {
        this.getEmailsTimer()
      },
      deep: true
    }
  },
  methods: {
    getEmails () {
      this.loading = true
      this.axios.get(`/api/account_emails/?per_page=${this.options.itemsPerPage}&page=${this.options.page}`).then((response) => {
        this.emails = response.data.results
        this.serverItemsLength = response.data.count
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.firstLoading = false
        this.loading = false
      })
    },
    getEmailsTimer () {
      clearTimeout(this.getTimer)
      this.getTimer = setTimeout(() => {
        this.getEmails()
      }, 100)
    },
    getDetails (item) {
      this.selectedItem = item
      this.editing = true
    },
    addEmail () {
      this.selectedItem = {
        account_email_id: null,
        name: ''
      }
      this.editing = true
    },
    close () {
      this.getEmailsTimer()
      this.editing = false
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/spa/account-settings/AccountEmails.vue